
import 'zone.js';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App.vue';
import './filters/to-fixed-filter';
import router from './router';
import store from './store';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration'
import TreeView from "vue-json-tree-view"

Vue.use(BootstrapVue);
Vue.use(TreeView);

Vue.config.productionTip = false;
Vue.config.ignoredElements = [
    'hyper-cloud-console',
    'hyper-backup'
];

new Vue({
	render: h => h(App),
	router,
	store,
}).$mount('#app');

Vue.filter('hyperDate', function(value) {
	if (value) {
		return dayjs(value).format('D MMM YYYY[,] HH:mm:ss');
	}
});

dayjs.extend(duration);